/**
 * The routes for public routes
 * @type {string[]}
 */
export const publicRoutes: string[] = [
    '/',
    '/auth/new-verification',
    '/terms',
    '/privacy',
];

/**
 * The routes for logging in
 * @type {string[]}
 */
export const authRoutes: string[] = [
    '/auth/login',
    '/auth/register',
    '/auth/error',
    '/auth/reset',
    '/auth/new-password',
    '/auth/email/confirm',
];

/**
 * The routes for protected routes
 * @type {string[]}
 */
export const protectedRoutes: string[] = ['/settings', '/dashboard'];

/**
 * The api prefix for all API authentication routes
 * @type {string}
 */
export const apiAuthPrefix: string = '/api/auth';

export const apiEmailPrefix: string = '/api/email';

export const apiWebhookPrefix: string = '/api/webhooks';

/**
 * Default redirect for logging in
 * @type {string}
 */
export const DEFAULT_LOGIN_REDIRECT: string = '/dashboard';
